import { Box, Typography, Paper, Avatar, Button } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export interface DRecord {
  id?: string;
  _id?: string;
  status?: string;
  currentStage?: string;
  firstName?: string;
  lastName?: string;
  employeeNumber?: string;
  total?: number;
  amount?: number;
  cost?: Record<string, unknown> | number;
  expiryDate?: string;
  triggerDate?: string;
  dueDate?: string;
  employee?: { id: string };
  submission?: string;
  legislation?: string;
  alertType?: string;
  actionRequired?: string;
  workflowType?: string;
  alertStatus?: string;
  startDate?: string;
  endDate?: string;
  certificationLevel?: string;
  demographics?: { race?: string; gender?: string };
  organisationalHierarchy?: { department?: string };
  [key: string]: unknown;
}

export const StatCard = ({ title, value, subtitle, trend, color = 'primary.main' }: { title: string; value: string | number; subtitle?: string; trend?: 'up' | 'down'; color?: string }) => (
  <Paper sx={{ p: 2.5, height: '100%' }}>
    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontWeight: 600 }}>{title}</Typography>
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 1 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color }}>{value}</Typography>
      {trend && (trend === 'up' ? <TrendingUp sx={{ fontSize: 18, color: 'success.main' }} /> : <TrendingDown sx={{ fontSize: 18, color: 'error.main' }} />)}
    </Box>
    {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
  </Paper>
);

export const WorkflowStatChip = ({ label, value, icon, color }: { label: string; value: number; icon: React.ReactNode; color: string }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Avatar sx={{ width: 28, height: 28, bgcolor: `${color}.light`, color: `${color}.dark` }}>{icon}</Avatar>
    <Box>
      <Typography variant="body2" fontWeight={600}>{value}</Typography>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
    </Box>
  </Box>
);

export const SectionHeader = ({ title, actionHref, actionLabel }: { title: string; actionHref?: string; actionLabel?: string }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>{title}</Typography>
      {actionHref && actionLabel && (
        <Button size="small" onClick={() => navigate(actionHref)}>{actionLabel} →</Button>
      )}
    </Box>
  );
};
